"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopulationType = void 0;
var PopulationType;
(function (PopulationType) {
    PopulationType["INITIAL_POPULATION"] = "initialPopulation";
    PopulationType["NUMERATOR"] = "numerator";
    PopulationType["NUMERATOR_EXCLUSION"] = "numeratorExclusion";
    PopulationType["DENOMINATOR"] = "denominator";
    PopulationType["DENOMINATOR_EXCLUSION"] = "denominatorExclusion";
    PopulationType["DENOMINATOR_EXCEPTION"] = "denominatorException";
    PopulationType["MEASURE_POPULATION"] = "measurePopulation";
    PopulationType["MEASURE_POPULATION_EXCLUSION"] = "measurePopulationExclusion";
    PopulationType["MEASURE_OBSERVATION"] = "measureObservation";
    PopulationType["DENOMINATOR_OBSERVATION"] = "denominatorObservation";
    PopulationType["NUMERATOR_OBSERVATION"] = "numeratorObservation";
    PopulationType["MEASURE_POPULATION_OBSERVATION"] = "measurePopulationObservation";
})(PopulationType = exports.PopulationType || (exports.PopulationType = {}));
